import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../PatUniv.js'

function PatDischargeSummary(props){

  const {ip_id} = useParams();
  const loc = 1;
  const [ipData, setIpData] = useState([]);
  const [labData, setLabData] = useState([]);
  const [disData, setdisData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [hospData, setHospData] = useState([]);
  const currentDate = new Date().toISOString().slice(0,10);

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "pat-edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
  useEffect(() => {
    fetchHosData();
  }, []);
  async function fetchHosData() {
      try {
        const response = await axios.get(baseUrl + "pat-view-hospital/" + loc + '/');
        setHospData(response.data);
      } catch (error) {
        console.log(error);
      }
  }

  useEffect(() => {
    fetchlabData();
  }, []);

  function fetchlabData() {
    axios.get(`${baseUrl}pat-view-ip-lab/${ip_id}`)
      .then((labResponse) => {
        setLabData(labResponse.data);
      })
      .catch(error => {
        console.log(error);
      });
  }


    useEffect(() => {
        fetchdisData();
    }, []);
    function fetchdisData() {
      axios.get(baseUrl + "pat-view-discharge/" + ip_id + "/")
        .then(response => {
          setdisData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };

    return (
    <section className="container mt-4">
    <div  id="invoice-print">
      <table rules="rows" cellpadding="3" className="text-justify mt-5" width="100%" >
        <thead>
          <tr>
            {hospData.map((hospital) => (
                <td align="right" colSpan="2" >
                  <p align="center">
                 <img
  src={hospital.logo}
  alt="Hospital Logo"
  style={{width:"60px", height:"60px", objectFit:"contain"}}
/>
<strong>{hospital.hospital}</strong><br />
                    Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                    <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                    Web : {hospital.website}
                  </p>
                </td>
            ))}
          </tr>
        </thead>
        </table>
    <h4 style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', justifyContent: 'space-between' }}>
      <span style={{ alignSelf: 'flex-start' }}>FINAL SETTLEMENT BILL/ RECEIPT</span>
      <span style={{ alignSelf: 'flex-end' }}>Date : {currentDate}</span>
    </h4>
    <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{patientData.admit_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
    </div>
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-file-invoice-dollar" aria-hidden="true" style={{ color: 'red' }}></i>
      Discharge Summary
    </h3>

  <div className="card card-body">
  <div className="table-responsive">
  <table className="erp-table-modern">
  <tbody>
    {disData.map((dis, index) => (
            <tr key={index}>
            <td dangerouslySetInnerHTML={{ __html: dis.dis_notes }}></td>
          </tr>
        ))}
    </tbody>
    </table>
    </div>
  </div>
    <table border='1' width="100%">
  <thead>
    <tr>
      <th className="text-end"><strong>For {hospData.map(row => row.hospital)}</strong></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td width="100%">
        <table width="100%">
          <tr>
            <th width="100%" className="text-end">Authorized Staff:</th>
          </tr>
          <tr>
            <th width="100%">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
          </tr>
          <tr>
            <th width="100%" className="text-end">(Name & Signature)</th>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</table>
</div>
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mt-2">
      <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
      onClick={handlePrint}
      >
       Print
      </button>
    </div>
    </section>
    )
}

export default PatDischargeSummary;